import { Button, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledComingSoonPage = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '100%',
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    paddingBottom: 'unset',
    justifyContent: 'center',
  },
}));

export const StyledContent = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  textAlign: 'center',
  height: '100%',
  [theme.breakpoints.up('lg')]: {
    justifyContent: 'center',
  },
}));

export const StyledBackButton = styled(Button)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    width: 'auto',
    alignSelf: 'flex-start',
  },
}));
